import { users_api_phone_verification_status_url } from 'mk/urls/functions';
import {
    PHONE_VERIFICATION_FETCH_TRIGGER,
    phoneVerificationFetchApi,
    PhoneVerificationFetchNormalizedResponse,
    PhoneVerificationFetchTriggerAction,
} from 'mk2/apps/users/containers/ManualPhoneVerification/ManualPhoneVerification.actions';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { normalize } from 'normalizr';
import { all, call, put, takeLatest } from 'redux-saga/effects';

const logger = getLogger('users/ManualPhoneVerification.sagas');

interface ApiResponseTopicInfo {
    body: {
        alreadyVerified: boolean;
    };
}

function* fetchPhoneVerificationStatus({ userId, xhr }: PhoneVerificationFetchTriggerAction & XHRAction) {
    yield put(phoneVerificationFetchApi.request(userId));

    try {
        const response: ApiResponseTopicInfo = yield call(
            () => xhr.get(users_api_phone_verification_status_url()),
        );

        const normalizedResponse: PhoneVerificationFetchNormalizedResponse = normalize(response.body, {});

        yield put(phoneVerificationFetchApi.success(userId, normalizedResponse));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(phoneVerificationFetchApi.failure(userId, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeLatest(PHONE_VERIFICATION_FETCH_TRIGGER, fetchPhoneVerificationStatus),
    ]);
}
